// This file is automatically generated. Do not edit manually.

import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { IsoDateTimeString } from "src/types/dateTime";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ControlChartEventsDataGridApi {
	export async function getGridData(args: {
		controlChartId?: number | null | undefined;
		chartGroupId?: number | null | undefined;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<ControlChartEventsDataGridApi_GridRow>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartEventsDataGrid/getGridData",
			method: "POST",
			data: {
				controlChartId: args.controlChartId,
				chartGroupId: args.chartGroupId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<ControlChartEventsDataGridApi_GridRow>;
	}
}

export interface ControlChartEventsDataGridApi_GridRow {
	controlChartId: number;
	controlChartName: string;
	createdAt: IsoDateTimeString | null | undefined;
	createdBy: string | null | undefined;
	description: string | null | undefined;
	eventId: number;
	ocs: string | null | undefined;
	processImprovementId: number | null | undefined;
	recordEnabled: boolean;
	recordId: number;
	recordObservationTime: IsoDateTimeString;
}
